var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ok-tick_svg__clip0_7556_14488)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ok-tick_svg__clip1_7556_14488)",
    fill: "#FFFCFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37 20.026a14 14 0 006.84 3.87 11.5 11.5 0 104.17-22.61 9.49 9.49 0 00-6.53 1 20.42 20.42 0 00-3.7 2.92 11.71 11.71 0 00-3.4 7.2c-.14 2.52 1.12 5.41 2.51 7.45.54.79 1.84 0 1.29-.76a13.81 13.81 0 01-2.23-5.54c-.31-2.09.71-4.39 1.87-6.08a12.35 12.35 0 013-3 8.5 8.5 0 015-1.94 10 10 0 016.6 17.74 10.33 10.33 0 01-7.3 2.25 12 12 0 01-7.07-3.63c-.64-.72-1.7.34-1.06 1.06l.01.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 14.336a25.195 25.195 0 002.68 3.06c.94.9 2.17 2.68 3.64 1.87.56-.43 1.021-.975 1.35-1.6.42-.61.82-1.25 1.21-1.89.82-1.33 1.58-2.69 2.34-4.06.76-1.37 1.44-2.64 2.23-3.93.59-1-.93-1.84-1.51-.88-1.69 2.77-3.13 5.69-4.85 8.45-.43.68-.87 1.36-1.35 2 0 0-.21.34-.27.36.16 0-.09-.17-.18-.26l-.83-.8a27.19 27.19 0 01-2.94-3.22.9.9 0 00-1.2-.31.88.88 0 00-.32 1.19v.02z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ok-tick_svg__clip0_7556_14488"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.74 .146)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ok-tick_svg__clip1_7556_14488"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.281 .813)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgOkTick;